/**
 * Turning the stored user into something showable.
 *
 * The API returns `firstName` / `lastName`; nothing sets a `name` field. Both
 * shells read `user.name`, so the admin bar showed an empty name and empty
 * initials, and the professional bar concatenated two undefined values into
 * the literal string "undefined undefined".
 */

/** @returns {string} full name, or the email, or '' - never "undefined". */
export function displayName(user) {
  if (!user) {
    return '';
  }

  const full = [user.firstName, user.lastName]
    .filter((part) => typeof part === 'string' && part.trim())
    .join(' ')
    .trim();

  if (full) {
    return full;
  }

  if (typeof user.name === 'string' && user.name.trim()) {
    return user.name.trim();
  }

  return typeof user.email === 'string' ? user.email : '';
}

/** @returns {string} up to two uppercase letters, or '' when nothing is known. */
export function initials(user) {
  const name = displayName(user);

  if (!name) {
    return '';
  }

  // An email has no space to split on, so fall back to its first letters.
  const source = name.includes(' ') ? name.split(/\s+/) : [name];

  return source
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase()
    .substring(0, 2);
}

export default { displayName, initials };
